import React, { useState } from "react";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdb-react-ui-kit";
import "./navbar.css";
import { useNavigate } from "react-router-dom";
import {
  canAccessPage,
  getToken,
  getTokenUser,
  isAdmin,
} from "../../helper/token";
import AxiosHelper from "../../helper/axios-helper";

function NavBar() {
  const navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState(getTokenUser());

  React.useEffect(() => {
    let user = getTokenUser();
    if (loggedInUser == null) {
      navigate("/login");
    }
    setLoggedInUser(user);
  }, []);

  //Create a on load place here to get the id of the user and then their role etc
  function onNavClick(selectedPage) {
    navigate("/" + selectedPage);
  }

  function onLogoutNav() {
    AxiosHelper.makeAxiosRequest(
      "Delete",
      "User",
      "logOut",
      { UserId: loggedInUser },
      null
    )
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
    navigate("/login");
  }

  function onRoleManagementNav() {
    navigate("/rolemanagement");
  }

  function onAdminNav() {
    navigate("/admin");
  }

  return (
    <MDBNavbar expand="lg" light bgColor="light">
      <MDBContainer fluid>
        <MDBNavbarBrand onClick={() => onNavClick("home")}>
          <img
            src={require("./bciLogoNew.png")}
            height="60"
            alt=""
            loading="lazy"
          />
        </MDBNavbarBrand>

        <MDBNavbarNav className="mr-auto mb-2 mb-lg-0">
          {canAccessPage("Proposal") && (
            <MDBNavbarItem onClick={() => onNavClick("home")}>
              <MDBNavbarLink
                active
                aria-current="page"
                href="#"
                id="nav-item-home"
                className="nav-item"
              >
                Proposal
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}

          {canAccessPage("Customer") && (
            <MDBNavbarItem onClick={() => onNavClick("customerlistview")}>
              <MDBNavbarLink
                active
                aria-current="page"
                href="#"
                id="nav-item-home"
                className="nav-item"
              >
                Customer
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}

          {canAccessPage("Vendor") && (
            <MDBNavbarItem onClick={() => onNavClick("vendorlist")}>
              <MDBNavbarLink
                active
                aria-current="page"
                href="#"
                id="nav-item-home"
                className="nav-item"
              >
                Vendor
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}

          {canAccessPage("Invoice") && (
            <MDBNavbarItem onClick={() => onNavClick("invoicelistview")}>
              <MDBNavbarLink
                active
                aria-current="page"
                href="#"
                id="nav-item-home"
                className="nav-item"
              >
                Invoice
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
        </MDBNavbarNav>
        <MDBDropdown>
          <MDBDropdownToggle tag="a" className="nav-link nav-item">
            <MDBIcon fas icon="bars" size="2x" />
          </MDBDropdownToggle>
          {canAccessPage("User Management") &&
            canAccessPage("Role Management") && (
              <MDBDropdownMenu>
                <MDBDropdownItem link onClick={onAdminNav}>
                  User Management
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={onRoleManagementNav}>
                  {" "}
                  Role Management{" "}
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={onLogoutNav}>
                  Log out
                </MDBDropdownItem>
              </MDBDropdownMenu>
            )}
          {canAccessPage("User Management") &&
            !canAccessPage("Role Management") && (
              <MDBDropdownMenu>
                <MDBDropdownItem link onClick={onAdminNav}>
                  User Management
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={onLogoutNav}>
                  Log out
                </MDBDropdownItem>
              </MDBDropdownMenu>
            )}
          {!canAccessPage("User Management") &&
            canAccessPage("Role Management") && (
              <MDBDropdownMenu>
                <MDBDropdownItem link onClick={onRoleManagementNav}>
                  {" "}
                  Role Management{" "}
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={onLogoutNav}>
                  Log out
                </MDBDropdownItem>
              </MDBDropdownMenu>
            )}
          {!canAccessPage("User Management") &&
            !canAccessPage("Role Management") && (
              <MDBDropdownMenu>
                <MDBDropdownItem link onClick={onLogoutNav}>
                  Log out
                </MDBDropdownItem>
              </MDBDropdownMenu>
            )}
        </MDBDropdown>
      </MDBContainer>
    </MDBNavbar>
  );
}

export default NavBar;
